export default __webpack_public_path__ + "static/media/undo.f4fbc84c.svg";